import { combineReducers } from "redux";

import lessons from "./lessons";

export default combineReducers({
    lessons,
});
